import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';

interface LogoProps {
  className?: string;
  variant?: 'dark' | 'light';
  /** Smaller size for mobile / tight spaces */
  compact?: boolean;
  /** Render as a link to /. Set false in footer where it's not interactive. */
  asLink?: boolean;
}

/**
 * The Laundry Co. wordmark — uses the actual hand-drawn script logo asset.
 *
 * The brand mark is a fashion-magazine script wordmark: high-contrast serif
 * "The" + flowing script "Laundry" + small serif "Co." (live in
 * /public/logo-script.png). Carries the brand's boutique-luxury voice and
 * shouldn't be substituted with a CSS-styled approximation.
 *
 * The `variant='light'` mode applies a CSS filter to render the dark logo as
 * cream on dark surfaces (footer, ink-coloured sections).
 */
export function Logo({ className, variant = 'dark', compact = false, asLink = true }: LogoProps) {
  const filter = variant === 'light' ? 'invert(94%) sepia(7%) saturate(290%) hue-rotate(5deg) brightness(106%)' : undefined;
  const height = compact ? 'h-7' : 'h-9 md:h-10';

  const img = (
    <img
      src="/logo-script.png"
      alt="The Laundry Co."
      className={cn(height, 'w-auto select-none', className)}
      style={filter ? { filter } : undefined}
      draggable={false}
    />
  );

  if (asLink) {
    return (
      <Link to="/" aria-label="The Laundry Co. — home" className="no-underline inline-block leading-none">
        {img}
      </Link>
    );
  }
  return img;
}
